import { FC } from 'react';
import { FormControl } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import { RegexTypeEnum, useCheckLatin } from 'hooks/useCheckRegex';
import { printf } from 'utils/i18n';
import patterns from 'utils/patterns';

interface FirstNameProps extends FormGroupProps {
    disabled?: boolean;
    placeholder?: string;
}

const FirstName: FC<FirstNameProps> = ({
    disabled,
    required,
    maxLength,
    pattern,
    validMessage,
    placeholder = __('First Name'),
    ...restProps
}) => {
    const {
        required: requiredMsg = printf(__('Please enter your %s'), __('first name')),
        maxLength: maxLengthMsg = __('Exceeded maximum length'),
        pattern: patternMsg = __('Please enter a valid name in English')
    } = validMessage || {};
    const { trigger: triggerCheckLatin, renderCheckingPrompt } = useCheckLatin(RegexTypeEnum.LATIN_NAME, 'first_name');

    return (
        <>
            <FormGroup
                label={__('First Name')}
                name="first_name"
                checker={value => {
                    if (disabled) {
                        return true;
                    }

                    // 默认必填
                    if ((required ?? true) && !value) {
                        return requiredMsg;
                    }

                    if (pattern ? !pattern.test(value) : !patterns.isEnglishName(value)) {
                        return patternMsg;
                    }

                    if (value.length > (maxLength ?? 20)) {
                        return maxLengthMsg;
                    }

                    return value ? triggerCheckLatin(value) : true;
                }}
                {...restProps}>
                <FormControl placeholder={placeholder} disabled={disabled} />
            </FormGroup>
            {renderCheckingPrompt()}
        </>
    );
};

export default FirstName;
